import React from "react";

const LoadableTeacherPlatform = React.lazy(
  () => import(/* webpackChunkName: "teacher-dashboard" */ "./teacher/Route")
);

export default LoadableTeacherPlatform;
